// Componente per la gestione dei messaggi di feedback

import React from 'react';
import {ClassName} from 'mgToolsKit';
import css from './message.module.less';
import PropTypes from 'prop-types';

// Init Configuration
var componentName = 'MessageComponent';

export default class Message extends React.Component {
    constructor(props) {
        super(props);

        this.timeoutAutoHide = 5000;
        this.timerTimeOut = null;
        this.state = {
            message: "Errore generico",
            view:true
        }
    }

    componentDidMount() {

        if (this.props.children != undefined && this.props.children != "") {
            this.setState({
                message: this.props.children
            });
        }

        if(this.props.autoHide){
          this.timerTimeOut =  setTimeout(() =>{
              this.setState(
                  {
                      view:false
                  }
              );
            }, this.timeoutAutoHide);
        }
    }    

    componentWillUnmount() {
        if(this.timerTimeOut != null){
            clearTimeout(this.timerTimeOut);
        }
    }

    render() {
        var  arrayClassName = [css["mg-message"]];
        arrayClassName.push(css["mg-"+this.props.type]);
        const  {className, align} = this.props;
        arrayClassName.push(css["mg-message-"+align]);

        
        if(className != undefined){
            arrayClassName.push(className);
        }
        
        var _className = ClassName(arrayClassName);

        
        return (
            <div style={!this.state.view?{display:"none"}:{}} className={_className}>
                <span>{this.state.message}</span>
            </div>
        )
    }
}

Message.displayName = componentName;

// PropTypes validation
Message.propTypes = {
    type: PropTypes.oneOf(['error', 'info','warning','success']),
    className: PropTypes.string,
    hideButton: PropTypes.bool,
    autoHide: PropTypes.bool,
    align: PropTypes.oneOf(['center', 'left','right']),
};

// default props
Message.defaultProps = {
    type: "error",
    hideButton: false,
    autoHide: false,
    align: "center"
};
Message.contextTypes = {
    /*
    * Context per la gestione del tema
    * */
    theme: PropTypes.object
}